import React from "react";
import { Caps, SecondaryMedium } from "@streeteasy/design-system/typography";

import { outeastIcon } from "../../assets";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TiktokIcon,
  TwitterIcon
} from "./icons";
import * as S from "./styled";

const socialArray = [
  {
    name: "facebook",
    icon: () => <FacebookIcon />,
    url: "https://www.facebook.com/streeteasy/"
  },
  {
    name: "linkedin",
    icon: () => <LinkedinIcon />,
    url: "https://www.linkedin.com/company/streeteasy"
  },
  {
    name: "twitter",
    icon: () => <TwitterIcon />,
    url: "https://twitter.com/streeteasy"
  },
  {
    name: "instagram",
    icon: () => <InstagramIcon />,
    url: "https://www.instagram.com/streeteasy/"
  },
  {
    name: "tiktok",
    icon: () => <TiktokIcon />,
    url: "https://www.tiktok.com/@streeteasy?lang=en"
  }
];

export default function SocialSection() {
  const handleAnalyticsOuteastClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "outeast",
      event_label: "click"
    });
  };

  return (
    <S.SocialIconsSection>
      <Caps as="h2">Follow StreetEasy for Updates</Caps>
      <S.SocialIcons>
        {socialArray.map(social => (
          <S.SocialLink
            key={social.url}
            href={social.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {social.name}
            {social.icon()}
          </S.SocialLink>
        ))}
      </S.SocialIcons>
      <S.SocialDivider />
      <S.OuteastLink
        href="https://outeast.com"
        onClick={handleAnalyticsOuteastClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        Out East Site
        <S.OuteastLogo alt="" loading="lazy" src={outeastIcon} />
      </S.OuteastLink>
      <SecondaryMedium as="h3">
        Buy or rent your Hamptons dream home
      </SecondaryMedium>
    </S.SocialIconsSection>
  );
}
